/* tslint:disable:no-string-literal */
import axios from 'axios';
import router from './router';
import store from './store';

import { AUTH_CLEAR } from './store/actions/auth.js';

import cachios from 'cachios';
var numberOfAjaxCAllPending = 0;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 20000,
});

function getAuthToken() {
  let authTokenRequest = store.state['auth'].token;
  if (authTokenRequest === null) {
    authTokenRequest = axiosInstance
      .post('/auth/refresh', {}, { withCredentials: true })
      .then( (response) => {
        // request complete and store
        store.commit('auth/refresh', response.data.access_token);
        return response.data.access_token;
      });
  }
  return authTokenRequest;
}

// Axios Intercept Requests
function removeLoader(){
  numberOfAjaxCAllPending--;    
  if (numberOfAjaxCAllPending <= 0) {
    numberOfAjaxCAllPending = 0
    store.dispatch('loader/done');
  }
}

axiosInstance.interceptors.request.use(
  async (config) => {
    if (!config.url!.includes('img')){
      numberOfAjaxCAllPending++;
    }    
    store.dispatch('loader/pending');
    // If not one of these specific pages that doesn't need a token,
    // use method to get the current token or request a new one.
    // Otherwise, use current token (possibly none)
    config.headers['version-front'] = '2.1'

    if (
      !config.url!.includes('login') &&
      !config.url!.includes('refresh') &&
      !config.url!.includes('forgot_password') &&
      !config.url!.includes('reset_password') &&
      !config.url!.includes('activate') &&
      !config.url!.includes('token')
    ) {
      config.headers['Authorization'] = 'Bearer ' + (await getAuthToken());
      /** Guardar el nuevo token */
    } else {
      const token = store.getters['auth/token'];
      if (typeof token !== 'undefined') {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
    }
    return config;
  },
  (error) => {
    removeLoader()
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (config) => {
    removeLoader()
    return config;
  },
  (error) => {
    // Prevent endless redirects (login is where you should end up)    
    removeLoader()
    if (error.request !== undefined) {
      if (error.request.responseURL.includes('login')) {
        return Promise.reject(error);
      }
    }

    // If you can't refresh your token or you are sent Unauthorized on any request, logout and go to login
    if (
      error.request !== undefined &&
      (error.request.responseURL.includes('refresh') ||
        (error.request.status === 403 && error.config.__isRetryRequest))
    ) {
      store.dispatch('AUTH_LOGOUT');
      router.push({ name: 'Login' });
    } else if (error.request !== undefined && error.request.status === 403) {
      error.config.__isRetryRequest = true;
      localStorage.removeItem('user-token');
      store.dispatch(AUTH_CLEAR);
      router.push('/login');
      return axios.request(error.config);
    }
    return Promise.reject(error);
  },
);

export const cachiosInstance = cachios.create(axiosInstance, {
  arrayValueSize: 80,
});

export default axiosInstance;
